var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64085 -4.54747e-13L1.64085 1.10155L6.11819 1.10155L0 7.22662L0.779116 8L6.89845 1.88296L6.89845 6.36718L8 6.36718L8 -4.54747e-13L1.64085 -4.54747e-13Z",
    transform: "matrix(0.70710677 -0.70710677 -0.70710677 -0.70710677 5.6567383 11.314453)",
    id: "Arrow",
    fill: "#007F00",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.f794106a1a537c4fb63832a715d5f69a.svg";
export { ForwardRef as ReactComponent };